var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-more"},[_c('div',{staticClass:"main",on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.state ? _vm.closeName : _vm.openName))]),_c('img',{attrs:{"src":_vm.state ? _vm.closeIcon : _vm.openIcon}})])])}
var staticRenderFns = []

export { render, staticRenderFns }